// import ConfirmationModal from './components/modals/ConfirmationModal.vue'
// Vue.component('confirmation-modal', ConfirmationModal)

document.addEventListener('DOMContentLoaded', function () {
  const bannerElement = document.getElementById('js-promo-banner');
  const bannerCloseButton = document.getElementById('js-promo-banner-close');
  //const bannerClosed = sessionStorage.getItem('promoBannerClosed');

  // if(bannerElement && !bannerClosed) {
  //   bannerElement.classList.add('show');
  // }

  if (bannerElement && bannerCloseButton) {
    bannerCloseButton.addEventListener('click', function () {
      bannerElement.classList.remove('show');
      //sessionStorage.setItem('promoBannerClosed', 'true');
    });
  }

})

$(document).ready(function () {
  let elsHasBg = document.querySelectorAll('[data-background]')
  elsHasBg.forEach((el) => {
    let attr = el.dataset.background
    if (typeof attr !== 'undefined' && attr !== false) {
      el.style.backgroundImage = 'url(' + attr + ')'
      el.style.backgroundRepeat = 'no-repeat'
    }
    let attrPosX = el.dataset.backgroundPositionX
    if (attrPosX !== undefined) {
      el.style.backgroundPositionX = attrPosX
    }
    let attrPosY = el.dataset.backgroundPositionY
    if (attrPosY !== undefined) {
      el.style.backgroundPositionY = attrPosY
    }
    let attrBgSize = el.dataset.backgroundSize
    if (attrBgSize !== undefined) {
      el.style.backgroundSize = attrBgSize
    }
    let attrBgRepeat = el.dataset.backgroundRepeat
    if (attrBgRepeat !== undefined) {
      el.style.backgroundRepeat = attrBgRepeat
    }
  })
})

$(document).click(function (e) {
  if (!$(e.target).is('#collapseMenu')) {
    $(document.querySelector('.menu')).collapse('hide')
    document.querySelector('.header__btn').classList.add('collapsed')
    document.querySelector('#collapseBackdrop').classList.remove('show')
  }
})
$(document).scroll(function (e) {
  if (!$(e.target).is('#collapseMenu')) {
    $(document.querySelector('.menu')).collapse('hide')
    document.querySelector('.header__btn').classList.add('collapsed')
    document.querySelector('#collapseBackdrop').classList.remove('show')
  }
})
$(document).ready(function (e) {
  $('#signupModal')
    .on('show.bs.modal', function () {
      $('body').css('overflow', 'hidden')
    })
    .on('hide.bs.modal', function () {
      $('body').css('overflow', 'auto')
    })
  $('#loginModal')
    .on('show.bs.modal', function () {
      $('body').css('overflow', 'hidden')
    })
    .on('hide.bs.modal', function () {
      $('body').css('overflow', 'auto')
    })

  $('.section-pro').each(function () {
    var highestBox = 0
    $(this)
      .find('.card-pro')
      .each(function () {
        if ($(this).height() > highestBox) {
          highestBox = $(this).height()
        }
      })
    $(this).find('.card-pro').height(highestBox)
  })
  $(function () {
    return $('.modal').on('show.bs.modal', function () {
      var curModal
      curModal = this
      $('.modal').each(function () {
        if (this !== curModal) {
          $(this).modal('hide')
        }
      })
    })
  })
})
